<form class="needs-validation" [formGroup]="myForm" novalidate>
   <div class="col-md-12 mb-3 pad-left">
      <div class="input-group">
         <div class="custom-file">
            <input #file id ="optFile" type="file" accept=".gif,.jpg,.jpeg,.png,.doc,.pdf,.docx
            ,.txt,.woff,.json,.ppt,.pptx,.xml,.jpeg,.xls,.xlsx" class="custom-file-input"  formControlName="optDoc"
            (change)="fileChange($event)" aria-label="Browse" [attr.disabled]="isBrowseDisabled ? true : null">
            <label label class="custom-file-label small-pad" for="optFile" aria-hidden="true">
               <ng-container *ngIf="optDoc">{{optDoc.name}}</ng-container>
            </label>
            
            <label *ngIf="myForm.controls['optDoc'].hasError('fileValidator')
                        || myForm.controls['optDoc'].hasError('sizeInvalid')
                        || myForm.controls['optDoc'].hasError('invalidFileCount')
                        || isBrowseDisabled"
               label class="custom-file-label label-error" for="optFile">
               <ng-container *ngIf="optDoc">{{optDoc.name}}</ng-container> 
            </label>
         </div>
      </div>
      <p class="err" *ngIf="myForm.controls['optDoc'].hasError('fileValidator')"> File type not accepted</p>
      <p class="err" *ngIf="myForm.controls['optDoc'].hasError('sizeInvalid')"> Please limit file size to 40 MB</p>
      <p class="err" *ngIf="myForm.controls['optDoc'].hasError('invalidFileCount') || isBrowseDisabled"> You have reached the limit of 10 files.
         To upload a different file, please remove one of the attachments from the list below.</p>
      <p class = "small-pad gray">Acceptable formats include .doc, .docx, .pdf, .jpg, .xlsx, .xls, .png and .gif (Duplicate files will not be included)</p> 
      <div class="col-md-7 no-pad">
         <div *ngIf="optDocs && optDocs.length == 0" id="no-states">
            <p id="light">No optional documents added yet</p>
         </div>
         <div id="no-states" *ngFor="let doc of optDocs; let i = index">
            <p style="font-family: Arial;">{{doc.name }} <span tooltip="Remove" placement="right" (click)="removeDoc(i)" class ="delete">X</span></p>
         </div>
      </div>
   </div>
</form>
